import React from "react";
import { MenuItem, SelectField } from "@curves/ui-base";

const SelectWithMenuItems = React.forwardRef(({ label, defaultValue, options = [], fullWidth = false, required, ...other }, ref) => (
	<SelectField key={defaultValue} ref={ref} label={label} defaultValue={defaultValue} fullWidth={fullWidth} required={required} {...other}>
		{Array.isArray(options) &&
			options.map(({ text, value }) => (
				<MenuItem key={value} value={value}>
					{text}
				</MenuItem>
			))}
	</SelectField>
));

SelectWithMenuItems.displayName = "SelectWithMenuItems";

export default SelectWithMenuItems;
